import PaginationNavigation from './PaginationNavigation';

export default angular.module('edge.platform.pagination', [])
    .component('gwPaginationNavigation', PaginationNavigation);